var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0778 58.774C22.0778 64.5934 17.3583 69.3129 11.5389 69.3129C5.71952 69.3129 1 64.5934 1 58.774V1.5H22.0678V58.774H22.0778Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5493 64.9434C14.9565 64.9434 17.7186 62.1813 17.7186 58.7741C17.7186 55.3668 14.9565 52.6047 11.5493 52.6047C8.14201 52.6047 5.37988 55.3668 5.37988 58.7741C5.37988 62.1813 8.14201 64.9434 11.5493 64.9434Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32004 9.73901H4.54004V13.519H8.32004V9.73901Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5486 9.73901H14.7686V13.519H18.5486V9.73901Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00977 21.8479H22.0776",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5488 27.8972V47.0552",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5459 50.2949V67.1731",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2971 81.2317L38.5771 92.5605C38.0671 94.7003 35.0171 94.7003 34.5071 92.5605L31.7871 81.2317V6.25951C31.7871 3.63979 33.9171 1.51001 36.5371 1.51001C39.1571 1.51001 41.2871 3.63979 41.2871 6.25951V81.2317H41.2971Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7969 81.2317H41.2969",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7969 75.6521H41.2969",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7969 8.95923H41.2969",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5459 94.0303V97.4902",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7171 8.95923C29.2871 8.95923 27.3271 10.929 27.3271 13.3488V29.8571",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9347 97.5H84.7812V50.6249L51.9347 50.6249L51.9347 97.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7812 86.2712C91.5305 86.2712 96.9999 80.8017 96.9999 74.0524C96.9999 67.3031 91.5305 61.8337 84.7812 61.8337",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7812 80.5019C88.3412 80.5019 91.2313 77.6122 91.2313 74.0526C91.2313 70.4929 88.3412 67.6033 84.7812 67.6033",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3645 66.0059L60.3105 74.0598L68.3645 82.1138L76.4185 74.0598L68.3645 66.0059Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5487 97.4999C17.3692 97.4999 22.0876 92.7815 22.0876 86.9611C22.0876 81.1406 17.3692 76.4221 11.5487 76.4221C5.7282 76.4221 1.00977 81.1406 1.00977 86.9611C1.00977 92.7815 5.7282 97.4999 11.5487 97.4999Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5484 92.1306C14.4034 92.1306 16.7178 89.8162 16.7178 86.9612C16.7178 84.1062 14.4034 81.7917 11.5484 81.7917C8.69337 81.7917 6.37891 84.1062 6.37891 86.9612C6.37891 89.8162 8.69337 92.1306 11.5484 92.1306Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3634 42.4357C79.6675 42.4357 88.8312 33.272 88.8312 21.9679C88.8312 10.6638 79.6675 1.5 68.3634 1.5C57.0593 1.5 47.8955 10.6638 47.8955 21.9679C47.8955 33.272 57.0593 42.4357 68.3634 42.4357Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9127 16.6685L68.3628 17.2184L67.8128 16.6685C67.3228 16.1785 66.7529 15.7885 66.103 15.4986C65.4431 15.2086 64.7531 15.0686 64.0232 15.0686C63.2933 15.0686 62.5534 15.2086 61.8934 15.4986C61.2335 15.7885 60.6636 16.1785 60.1836 16.6685C59.6937 17.1584 59.3137 17.7283 59.0437 18.3783C58.7738 19.0382 58.6338 19.7281 58.6338 20.4581C58.6338 21.188 58.7738 21.9279 59.0437 22.5878C59.3137 23.2478 59.7037 23.8177 60.1836 24.2977L68.3727 32.4368L76.5619 24.2977C77.0518 23.8077 77.4318 23.2378 77.7018 22.5878C77.9717 21.9279 78.1118 21.228 78.1118 20.4581C78.1118 19.6881 77.9717 19.0282 77.7018 18.3783C77.4318 17.7183 77.0418 17.1484 76.5619 16.6685C76.0819 16.1885 75.502 15.7885 74.8521 15.4986C74.1922 15.2086 73.4922 15.0686 72.7223 15.0686C71.9524 15.0686 71.2924 15.2086 70.6425 15.4986C69.9826 15.7885 69.4127 16.1785 68.9327 16.6685H68.9127Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.2739dd7d758d73393069d6b0c2fe002b.svg";
export { ForwardRef as ReactComponent };